




















import {Component, Vue} from "vue-property-decorator";
import {State} from "vuex-class";
import {VideoInterface} from "@/models/video";

@Component
export default class MusicalPracticaCategory extends Vue{
    @State(state => state.video.musical) videos: VideoInterface[];


    get VideosId() {
        return this.videos.filter(e => e.category.id === this.$route.params.categoryId)
    }
}
